// Auren Residence — carried over from the previous single-project data with no
// editorial changes. Fields are mapped mechanically into the shared schema.
const aurenResidence = {
  id: 'winchester-residences',
  slug: 'auren-residence',
  name: 'Auren Residence',
  category: 'Residential Development',

  status: 'now-selling',
  featured: false,
  listed: true,

  location: {
    area: 'Ikoyi',
    city: 'Lagos',
    display: 'Ikoyi, Lagos, Nigeria',
    mapEmbedUrl: null,
    nearby: [],
  },

  shortDescription:
    'A luxury multi-storey residential development in Ikoyi by Winchester Construction in partnership with Plot Kapital Development Company — 20+ two and three bedroom units, now selling off-plan.',
  overviewHeading: 'A luxury residential development in Ikoyi',
  fullDescription: [
    'Auren Residence is a premium multi-storey residential development by Winchester Construction in partnership with Plot Kapital Development Company. Comprising 20+ thoughtfully designed units across two and three bedroom configurations, the development delivers modern living with high-quality finishes throughout.',
    'Each unit is available for outright purchase or as a managed shortlet investment with consistent rental income, managed end-to-end by NimbleCasa. An ideal choice for owner-occupiers and real estate investors alike.',
  ],

  // short marketing line shown on the homepage preview card
  keyFeatures: ['On-site Gym', '24-Hour Power', 'Modern Fitted Kitchen', 'CCTV Security'],
  quickFacts: [
    { label: 'Total Units', value: '20+' },
    { label: 'Bedrooms', value: '2 – 3' },
    { label: 'Location', value: 'Ikoyi' },
    { label: 'Status', value: 'Now Selling' },
  ],

  unitCountLabel: '20+ Units',
  unitMix: [
    { type: '2 Bedroom Apartment', count: 12 },
    { type: '3 Bedroom Apartment', count: 8 },
  ],
  unitTypes: [
    { type: '2 Bedroom Apartment', units: 12, size: '~85 sqm', bedrooms: 2, bathrooms: 2, priceLabel: 'Contact for Pricing' },
    { type: '3 Bedroom Apartment', units: 8, size: '~120 sqm', bedrooms: 3, bathrooms: 3, priceLabel: 'Contact for Pricing' },
  ],

  amenities: [
    { icon: '⚡', name: '24-Hour Power Supply' },
    { icon: '🍳', name: 'Modern Fitted Kitchen' },
    { icon: '🛗', name: 'Elevator Access' },
    { icon: '📷', name: 'CCTV Security' },
    { icon: '🏋️', name: 'On-site Gym' },
    { icon: '🛋️', name: 'Spacious Living Areas' },
    { icon: '🔧', name: 'Facility Management' },
  ],

  parking: { show: false, heading: null, body: null, image: null },
  lift: { show: false, note: null },

  hero: {
    src: '/project-media/auren-residence/hero.jpg',
    srcWebp: null,
    srcSmall: '/project-media/auren-residence/hero-900.jpg',
    alt: 'Architectural render of Auren Residence, Ikoyi, Lagos',
    width: 1400,
    height: 560,
  },
  cardImage: {
    src: '/project-media/auren-residence/hero-900.jpg',
    alt: 'Auren Residence, Ikoyi, Lagos',
    width: 900,
    height: 360,
  },
  gallery: [],
  floorPlans: [],
  brochure: {
    label: 'Project Flyer',
    thumb: '/project-media/auren-residence/brochure-thumb.jpg',
    file: '/project-media/auren-residence/brochure.jpg',
  },

  partners: [
    { role: 'Developed By', name: 'Winchester Construction', logo: null },
    { role: 'Development Partner', name: 'Plot Kapital Development', logo: null },
    { role: 'Sales & Investment Partner', name: 'NimbleCasa', logo: null },
  ],

  enquiry: {
    phone: '09168584819',
    whatsappHref: null,
    prefillInterest: 'Auren Residence',
  },

  seo: {
    title: 'Auren Residence | Luxury Apartments in Ikoyi | NimbleCasa',
    description:
      'Auren Residence — 20+ luxury two and three bedroom apartments in Ikoyi, Lagos, by Winchester Construction and Plot Kapital Development. Outright purchase or managed shortlet investment through NimbleCasa.',
    ogImage: '/project-media/auren-residence/og.jpg',
  },
};

export default aurenResidence;
